export const POST_ORDERS_REQUEST = "POST_ORDERS_REQUEST";
export const POST_ORDERS_SUCCESS = "POST_ORDERS_SUCCESS";
export const POST_ORDERS_FAILURE = "POST_ORDERS_FAILURE";

export const GET_ORDERS_REQUEST = "GET_ORDERS_REQUEST";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAILURE = "GET_ORDERS_FAILURE";
